import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import { validateArrayWith } from '@/api/workspace/endpoints/validateArrayWith.ts';
import { SavedBlotterValidator } from '@/domain/WorkspaceForex/SavedBlotter/SavedBlotter.ts';
import { SavedCashForwardValidator } from '@/domain/WorkspaceForex/savedProducts/cash/SavedCashForward.ts';
import { SavedCashNdfValidator } from '@/domain/WorkspaceForex/savedProducts/cash/SavedCashNdf.ts';
import { SavedCashSpotValidator } from '@/domain/WorkspaceForex/savedProducts/cash/SavedCashSpot.ts';
import { SavedFlexiForwardValidator } from '@/domain/WorkspaceForex/savedProducts/flexi-forward/SavedFlexiForward';
import { SavedForwardAccumulatorValidator } from '@/domain/WorkspaceForex/savedProducts/forwardAccumulator/SavedForwardAccumulator.ts';
import { SavedOptionValidator } from '@/domain/WorkspaceForex/savedProducts/option/SavedOption.ts';
import { SavedCallOrderValidator } from '@/domain/WorkspaceForex/savedProducts/order/SavedCallOrder.ts';
import { SavedFalconOrderValidator } from '@/domain/WorkspaceForex/savedProducts/order/SavedFalconOrder.ts';
import { SavedFixingOrderValidator } from '@/domain/WorkspaceForex/savedProducts/order/SavedFixingOrder.ts';
import { SavedNightjarOrderValidator } from '@/domain/WorkspaceForex/savedProducts/order/SavedNightjarOrder.ts';
import { SavedStopLossOrderValidator } from '@/domain/WorkspaceForex/savedProducts/order/SavedStopLossOrder.ts';
import { SavedTakeProfitOrderValidator } from '@/domain/WorkspaceForex/savedProducts/order/SavedTakeProfitOrder.ts';
import { SavedTwapOrderValidator } from '@/domain/WorkspaceForex/savedProducts/order/SavedTwapOrder.ts';
import { SavedSwapNdsValidator } from '@/domain/WorkspaceForex/savedProducts/swap/SavedSwapNds.ts';
import { SavedSwapRegularValidator } from '@/domain/WorkspaceForex/savedProducts/swap/SavedSwapRegular.ts';
import { SavedTargetAccumulatorValidator } from '@/domain/WorkspaceForex/savedProducts/targetAccumulator/SavedTargetAccumulator.ts';
import { SavedTabValidator } from '@/domain/WorkspaceForex/SavedTab.ts';
import { SavedTileValidator } from '@/domain/WorkspaceForex/SavedTile.ts';

/**
 * @See: [./arktype.md](docs)
 */
export const WorkspaceValidator = arkScope.type({
  version: arkScope.type.enumerated(10),
  canTrade: 'boolean',
  tabs: SavedTabValidator.array().default(() => []),
  selectedTabId: 'string',
  tiles: SavedTileValidator.array().default(() => []),
  products: {
    cash: validateArrayWith(SavedCashSpotValidator.or(SavedCashForwardValidator).or(SavedCashNdfValidator)),
    swap: validateArrayWith(SavedSwapRegularValidator.or(SavedSwapNdsValidator)),
    option: validateArrayWith(SavedOptionValidator),
    targetAccumulator: validateArrayWith(SavedTargetAccumulatorValidator),
    forwardAccumulator: validateArrayWith(SavedForwardAccumulatorValidator),
    order: validateArrayWith(
      SavedStopLossOrderValidator.or(SavedTakeProfitOrderValidator)
        .or(SavedFixingOrderValidator)
        .or(SavedCallOrderValidator)
        .or(SavedTwapOrderValidator)
        .or(SavedFalconOrderValidator)
        .or(SavedNightjarOrderValidator),
    ),
    flexiForward: validateArrayWith(SavedFlexiForwardValidator),
  },
  blotter: SavedBlotterValidator.optional(),
});

export type WorkspaceForex = typeof WorkspaceValidator.infer;
